import { apiClient } from './api/apiClient';
import type { ApiResponse, PagedResponse } from '../types';

export interface Company {
  id: number;
  name: string;
  type: string;
  ownerId: number;
  ownerName: string;
  ownerEmail: string;
  vatNumber?: string;
  address?: string;
  city?: string;
  country: string;
  subscriptionPlan: string;
  subscriptionExpiresAt?: string;
  tenantCode?: string;
  loyaltyEnabled: boolean;
  isActive: boolean;
  siteCount: number;
  employeeCount: number;
  createdAt: string;
}

export interface CreateCompanyRequest {
  name: string;
  type: number;
  vatNumber?: string;
  address?: string;
  city?: string;
  country?: string;
  subscriptionPlan?: number;
  tenantCode?: string;
  loyaltyEnabled?: boolean;
  ownerEmail: string;
  ownerFirstName: string;
  ownerLastName: string;
  ownerPassword: string;
}

export interface UpdateCompanyRequest {
  name?: string;
  type?: number;
  vatNumber?: string;
  address?: string;
  city?: string;
  subscriptionPlan?: number;
  tenantCode?: string;
  loyaltyEnabled?: boolean;
  isActive?: boolean;
}

export interface CompanyFilter {
  page?: number;
  pageSize?: number;
  isActive?: boolean;
  type?: number;
  search?: string;
}

class CompanyService {
  /**
   * Ottieni lista aziende con filtri e paginazione
   */
  async getCompanies(filter?: CompanyFilter): Promise<PagedResponse<Company>> {
    const params = new URLSearchParams();

    if (filter) {
      if (filter.isActive !== undefined) params.append('isActive', filter.isActive.toString());
      if (filter.type !== undefined) params.append('type', filter.type.toString());
      if (filter.search) params.append('search', filter.search);
      if (filter.page) params.append('page', filter.page.toString());
      if (filter.pageSize) params.append('pageSize', filter.pageSize.toString());
    }

    return await apiClient.get<PagedResponse<Company>>(
      `/companies?${params.toString()}`
    );
  }

  /**
   * Ottieni dettagli azienda per ID
   */
  async getCompanyById(id: number): Promise<ApiResponse<Company>> {
    return await apiClient.get<ApiResponse<Company>>(`/companies/${id}`);
  }

  /**
   * Crea nuova azienda con owner
   */
  async createCompany(data: CreateCompanyRequest): Promise<ApiResponse<Company>> {
    return await apiClient.post<ApiResponse<Company>>('/companies', data);
  }

  /**
   * Aggiorna azienda esistente
   */
  async updateCompany(id: number, data: UpdateCompanyRequest): Promise<ApiResponse<Company>> {
    return await apiClient.put<ApiResponse<Company>>(`/companies/${id}`, data);
  }

  /**
   * Disattiva azienda (soft delete)
   */
  async deactivateCompany(id: number): Promise<void> {
    return await apiClient.delete(`/companies/${id}`);
  }
}

export const companyService = new CompanyService();
